
export const theme = {
    lightGrey: '#dcddde',
    medLightGrey: '#b9bbbe',
    medGrey: '#8e9297',
    medDarkGrey: '#4f545c',
    darkGrey: '#36393f',
    darkerGrey: '#202225',
    darkestGrey: '#18191c',

    blueLink: '#00b0f4',
    lightPurple: '#8ea1e1',
    purple: '#7289da',
    green: '#42b581',

}
